/**
 * Status indicator component for Proctoring SDK
 * Shows monitoring state and consumed duration timer.
 */

class StatusIndicator {
  element = null;
  shadowRoot = null;
  minimized = false;
  options = {
    position: "top-right",
  };
  status = {
    camera: false,
    screen: false,
    durationSeconds: 0,
  };

  formatDuration(totalSeconds) {
    const seconds = Math.max(0, Number(totalSeconds || 0));
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const hh = String(hrs).padStart(2, "0");
    const mm = String(mins).padStart(2, "0");
    const ss = String(secs).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  }

  init(shadowRoot, options = {}) {
    this.shadowRoot = shadowRoot;
    this.options = { ...this.options, ...options };

    this.element = document.createElement("div");
    this.element.className = `status-indicator pos-${this.options.position}`;
    this.element.addEventListener("click", () => this.toggle());

    this.render();
    this.shadowRoot.appendChild(this.element);
  }

  render() {
    const isActive = this.status.camera || this.status.screen;
    const statusText = isActive ? "Monitoring Active" : "Monitoring Paused";
    const timerText = this.formatDuration(this.status.durationSeconds);

    this.element.innerHTML = `
            <span class="status-dot ${isActive ? "" : "inactive"}"></span>
            <span class="status-text">${statusText}</span>
            <span class="status-timer">${timerText}</span>
        `;
  }

  updateStatus(camera, screen) {
    this.status.camera = camera;
    this.status.screen = screen;
    this.render();
  }

  updateDuration(seconds) {
    this.status.durationSeconds = Number(seconds || 0);
    this.render();
  }

  toggle() {
    this.minimized = !this.minimized;
    this.element.classList.toggle("minimized", this.minimized);
  }

  minimize() {
    this.minimized = true;
    this.element.classList.add("minimized");
  }

  expand() {
    this.minimized = false;
    this.element.classList.remove("minimized");
  }

  show() {
    this.element.style.display = "";
  }

  hide() {
    this.element.style.display = "none";
  }

  destroy() {
    this.element?.remove();
    this.element = null;
  }
}

export default new StatusIndicator();
